<script>
	import Layout from "../../layouts/main"
	import PageHeader from "@/components/page-header"
	import appConfig from "@/app.config"
	import Multiselect from "vue-multiselect"
	import DatePicker from "vue2-datepicker"
	import VueTimepicker from "vue2-timepicker"
	import 'vue2-timepicker/dist/VueTimepicker.css'

	export default {
		middleware: "authentication",
		components: {
			Layout,
			PageHeader,
			Multiselect,
			DatePicker,
			VueTimepicker,
		},
		page: {
			title: "Edit Employee details",
			meta: [
				{
					name: "description",
					content: appConfig.description,
				},
			],
		},
		data: function() {
			return {
				title: 'Employee',
				items: [
					{
						text: "View",
					},
					{
						text: "Employee List",
						active: true,
					},
				],
				overtimeApplicableOptions: [
					{text: 'Yes', value: true},
					{text: 'No', value: false},
				],
				isManagerOptions: [
					{text: 'Yes', value: true},
					{text: 'No', value: false},
				],
				employeeId: '',
				branches: [],
				selectedBranch: '',
				employeeDetails: {
					employeeName: '',
					phoneNumber: '',
					employeeDob: '',
					emailId: '',
					address: '',
					branchId: '',
					dateOfJoining: '',
					designation: '',
					role: '',
					bankDetails: {
						BankAccNo: '',
						BankName: '',
						ifsc: '',
						branchName: '',
					},
					isOvertimeApplicable: 'No',
					isManager: false,
					reportingManager: '',
					allowedLeaves: '',
					shift: {
						startTime: '',
						endTime: '',
						shiftType: '',
						shiftHours: '',
					},
					leaves: {
						CasualLeaveBalanceCurrentYear: '',
						SickLeaveBalanceCurrentYear: '',
						TotalAnnualCasualLeavesPaid: '',
						TotalAnnualSickLeavesPaid: '',
					},
					locationRadiusBoundInMeter: 0,
					monthlyAllowedExpense: 0,
					salary: '',
					payroll: {
						PFDeduction: '',
						PFContribution: '',
						ESICDeduction: '',
						ESICContribution: '',
						OtherStatutoryDeductions: '',
						ConveyanceAllowances: 0,
						HouseRentAllowances: 0,
						MedicalAllowances: 0,
						ProfessionalTax: 0,
						SpecialAllowances: 0,
					},
				},
				managers: [],
				selectedManager: '',
			};
		},
		mounted: function() {
			this.employeeId = this.$route.params.id
			this.getBranchList()
		},
		methods: {
			goBack: function() {
				this.$router.go(-1);
			},
			getBranchList: function() {
				this.$api.post('corporate/get-branch', {
					corporateId: (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId,
				}).then(result => {
					this.branches = result.data.data
					// this.employeeDetails.branchId = this.branches[0]._id
					this.getEmployeeDetails()
				}).catch(error => {
					console.log(error)
				})
			},
			getEmployeeDetails: function() {
				this.$api.post('getEmployeeDetailById', {
					employeeId: this.employeeId,
				}).then(response => {
					console.log(response.data)
					let statusCode = response.data.responseCode
					if (statusCode === 200) {
						let employee = response.data.data.EmployeeDetails
						this.managers = response.data.data.Managers
						this.employeeDetails.employeeName = employee.name
						this.employeeDetails.phoneNumber = employee.phoneNumber.toString().substring(2, employee.phoneNumber.length)
						this.employeeDetails.employeeDob = new Date(this.$moment(employee.DateOfBirth).format('DD MMM Y'))
						this.employeeDetails.dateOfJoining = new Date(this.$moment(employee.DateOfJoining).format('DD MMM Y'))
						this.employeeDetails.emailId = employee.email
						this.employeeDetails.address = employee.Address
						this.employeeDetails.designation = employee.designation
						this.employeeDetails.role = employee.role
						this.employeeDetails.isManager = employee.isManager
						this.employeeDetails.branchId = employee.branchId
						this.selectedBranch = this.branches.filter(branch => branch._id === this.employeeDetails.branchId)
						this.employeeDetails.allowedLeaves = employee.allowedLeaves != null ? employee.allowedLeaves : 0
						this.employeeDetails.isOvertimeApplicable = employee.OvertimeApplicable == 'true' ? true : false
						this.employeeDetails.locationRadiusBoundInMeter = employee.locationRadiusBoundInMeter
						this.employeeDetails.monthlyAllowedExpense = employee.monthlyAllowedExpense
						this.employeeDetails.salary = employee.Salary.$numberDecimal
						this.employeeDetails.payroll.PFDeduction = employee.payroll.PFDeduction.$numberDecimal
						this.employeeDetails.payroll.PFContribution = employee.payroll.PFContribution.$numberDecimal
						this.employeeDetails.payroll.ESICDeduction = employee.payroll.ESICDeduction.$numberDecimal
						this.employeeDetails.payroll.ESICContribution = employee.payroll.ESICContribution.$numberDecimal
						this.employeeDetails.payroll.OtherStatutoryDeductions = employee.payroll.OtherStatutoryDeductions.$numberDecimal
						this.employeeDetails.payroll.ConveyanceAllowances = employee.payroll.ConveyanceAllowances.$numberDecimal
						this.employeeDetails.payroll.HouseRentAllowances = employee.payroll.HouseRentAllowances.$numberDecimal
						this.employeeDetails.payroll.MedicalAllowances = employee.payroll.MedicalAllowances.$numberDecimal
						this.employeeDetails.payroll.ProfessionalTax = employee.payroll.ProfessionalTax.$numberDecimal
						this.employeeDetails.payroll.SpecialAllowances = employee.payroll.SpecialAllowances.$numberDecimal
						this.employeeDetails.reportingManager = employee.managerId
						this.selectedManager = this.managers.filter(manager => manager._id === employee.managerId)
						this.employeeDetails.bankDetails.BankAccNo = employee.BankDetail.BankAccNo
						this.employeeDetails.bankDetails.BankName = employee.BankDetail.BankName
						this.employeeDetails.shift.shiftHours = employee.shift.shiftHours
						this.employeeDetails.shift.shiftType = employee.shift.shiftType
						this.employeeDetails.shift.startTime = this.$moment(employee.shift.startTime).format('hh:mm A')
						this.employeeDetails.shift.endTime = this.$moment(employee.shift.endTime).format('hh:mm A')
						this.employeeDetails.leaves.CasualLeaveBalanceCurrentYear = employee.leaves.CasualLeaveBalanceCurrentYear
						this.employeeDetails.leaves.SickLeaveBalanceCurrentYear = employee.leaves.SickLeaveBalanceCurrentYear
						this.employeeDetails.leaves.TotalAnnualCasualLeavesPaid = employee.leaves.TotalAnnualCasualLeavesPaid
						this.employeeDetails.leaves.TotalAnnualSickLeavesPaid = employee.leaves.TotalAnnualSickLeavesPaid
					}
				}).catch(error => {
					console.log(error)
				})
			},
			selectBrnach: function(option) {
				this.employeeDetails.branchId = option._id
			},
			selectManager: function(option) {
				console.log(option)
				this.employeeDetails.reportingManager = option._id
			},
			updateEmployeeDetails: function() {
				this.$api.post('editEmployeeDetails', {
					employeeId: this.employeeId,
					name: this.employeeDetails.employeeName,
					phoneNumber: this.employeeDetails.phoneNumber,
					Address: this.employeeDetails.address,
					branchId: this.employeeDetails.branchId,
					DOB: this.employeeDetails.employeeDob,
					DOJ: this.employeeDetails.dateOfJoining,
					overTimeApplicable: this.employeeDetails.overTimeApplicable,
					Salary: this.employeeDetails.salary,
					allowedLeaves: this.employeeDetails.allowedLeaves,
					designation: this.employeeDetails.designation,
					email: this.employeeDetails.emailId,
					isManager: this.employeeDetails.isManager,
					leaves: this.employeeDetails.leaves,
					managerId: this.employeeDetails.reportingManager,
					BankDetail: this.employeeDetails.bankDetails,
					payroll: this.employeeDetails.payroll,
					shift: this.employeeDetails.shift,
					locationRadiusBoundInMeter: this.employeeDetails.locationRadiusBoundInMeter,
					monthlyAllowedExpense: this.employeeDetails.monthlyAllowedExpense,
				}).then(response => {
					console.log(response.data)
					const status = response.data.responseCode
					if (status === 200) {
						this.$toast.success(response.data.response, {
							position: "top-right",
							timeout: 5000,
							closeOnClick: true,
							pauseOnFocusLoss: true,
							pauseOnHover: true,
							draggable: true,
							draggablePercent: 0.6,
							showCloseButtonOnHover: false,
							hideProgressBar: false,
							closeButton: "button",
							icon: true,
							rtl: false
						})
					}
					if (status === 400) {
						this.$toast.error(response.data.response, {
							position: "top-right",
							timeout: 5000,
							closeOnClick: true,
							pauseOnFocusLoss: true,
							pauseOnHover: true,
							draggable: true,
							draggablePercent: 0.6,
							showCloseButtonOnHover: false,
							hideProgressBar: false,
							closeButton: "button",
							icon: true,
							rtl: false
						})
					}
				}).catch(error => {
					console.log(error)
				})
			},
		},
	}
</script>
<style>
	textarea {
		resize: none;
	}
	.card-title {
		margin: 0;
	}
	.back-button .card-title {
		margin-left: 15px;
	}
	.back-button button i {
		margin-right: 10px;
	}
	.custom-control {
		position: relative;
		z-index: 1;
		display: block;
		min-height: 1rem;
		padding-left: 1rem;
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
	}
	.custom-control-inline {
		display: -ms-inline-flexbox;
		display: inline-flex;
		margin-right: 1rem;
	}
	.custom-control-inline:last-child {
		margin-right: 0;
	}
	.custom-control-input {
		position: absolute;
		left: 0;
		z-index: -1;
		width: 1rem !important;
		height: 1.25rem !important;
		opacity: 0;
	}
	.custom-control-label {
		position: relative;
		margin-bottom: 0 !important;
		vertical-align: top;
		padding-left: .5rem;
	}
	.custom-control-label:before {
		pointer-events: none;
		background-color: #fff;
		border: 1px solid #adb5bd;
		transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	}
	.custom-radio .custom-control-label:before {
		border-radius: 50%;
	}
	.custom-control-label:after, .custom-control-label:before {
		position: absolute;
		top: .25rem;
		left: -1rem;
		display: block;
		width: 1rem;
		height: 1rem;
		content: '';
	}
	.custom-control-label:after {
		background: 50%/50% 50% no-repeat;
	}
	.custom-control-input:checked~.custom-control-label:before {
		color: #fff;
		border-color: #EB455F;
		background-color: #EB455F;
	}
	.custom-radio .custom-control-input:checked~.custom-control-label:after {
		background-image: url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'> <circle r='3' fill='%23fff'/> </svg>");
	}
</style>
<template>
	<Layout>
		<PageHeader :items="items" />
		<div class="row">
			<div class="col-12">
				<b-form @submit.prevent="updateEmployeeDetails">
					<div class="card mb-4">
						<div class="card-body">
							<div class="d-flex flex-row align-items-center back-button">
								<b-button variant="primary" @click="goBack()">
									<i class="mdi mdi-arrow-left"></i>
									<span>Back</span>
								</b-button>
								<h4 class="card-title">Edit Employee details</h4>
							</div>
						</div>
					</div>
					<div class="card mb-4">
						<div class="card-body">
							<h4 class="card-title">Personal Details</h4>
							<div class="p-2 mt-4">
								<div class="row">
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Employee Name" for="employeeName">
											<b-form-input id="employeeName" v-model="employeeDetails.employeeName" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Phone Number" for="phoneNumber">
											<b-form-input id="phoneNumber" v-model="employeeDetails.phoneNumber" />
										</b-form-group>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Date of Birth" for="employeeDob">
											<date-picker id="employeeDob" format="DD MMM Y" append-to-body lang="en" v-model="employeeDetails.employeeDob" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Email ID" for="emailId">
											<b-form-input id="emailId" v-model="employeeDetails.emailId" />
										</b-form-group>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Address" for="address">
											<b-form-textarea id="address" v-model="employeeDetails.address" />
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-4">
						<div class="card-body">
							<h4 class="card-title">Bank Details</h4>
							<div class="p-2 mt-4">
								<div class="row">
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Bank Name" for="bankName">
											<b-form-input id="bankName" v-model="employeeDetails.bankDetails.BankName" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Account Number" for="bankAccountNumber">
											<b-form-input id="bankAccountNumber" v-model="employeeDetails.bankDetails.BankAccNo" />
										</b-form-group>
									</div>
									<!-- <div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="IFSC Code" for="ifscCode">
											<b-form-input id="ifscCode" v-model="employeeDetails.bankDetails.ifsc" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Branch Name" for="branchName">
											<b-form-input id="branchName" v-model="employeeDetails.bankDetails.branchName" />
										</b-form-group>
									</div> -->
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-4">
						<div class="card-body">
							<h4 class="card-title">Official Details</h4>
							<div class="p-2 mt-4">
								<div class="row">
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Date of Joining" for="dateOfJoining">
											<date-picker id="dateOfJoining" format="DD MMM Y" append-to-body lang="en" v-model="employeeDetails.dateOfJoining" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Designation" for="designation">
											<b-form-input id="designation" v-model="employeeDetails.designation" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Branch" for="branch">
											<multiselect id="branch" v-model="selectedBranch" :options="branches" @input="selectBrnach" placeholder="Select Branch" :multiple="false" track-by="_id" label="name" :allow-empty="false">
												<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
											</multiselect>
										</b-form-group>
									</div>
									<!-- <div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Role" for="role">
											<b-form-input id="role" v-model="role" />
										</b-form-group>
									</div> -->
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Overtime Applicable" for="isOvertimeApplicable">
											<b-form-radio-group
												id="isOvertimeApplicable"
												v-model="employeeDetails.isOvertimeApplicable"
												name="overtime">
												<b-form-radio value=true>Yes</b-form-radio>
												<b-form-radio value=false>No</b-form-radio>
											</b-form-radio-group>
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Is Manager" for="isManager">
											<b-form-radio-group
												id="isManager"
												v-model="employeeDetails.isManager"
												:options="isManagerOptions"
												name="manager" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Reporing Manager" for="reportingManager">
											<multiselect id="reportingManager" v-model="selectedManager" @input="selectManager" :options="managers" placeholder="Select Manager" :multiple="false" track-by="_id" label="name" :allow-empty="false">
												<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
											</multiselect>
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Allowed Leaves" for="allowedLeaves">
											<b-form-input id="allowedLeaves" v-model="employeeDetails.allowedLeaves" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<div class="row">
											<b-form-group class="mb-3 col-md-3" label="Shift Type" for="shiftType">
												<b-form-input id="shiftType" v-model="employeeDetails.shift.shiftType" />
											</b-form-group>
											<b-form-group class="mb-3 col-md-3" label="Shift Hours" for="shiftHours">
												<b-form-input id="shiftHours" v-model="employeeDetails.shift.shiftHours" />
											</b-form-group>
											<b-form-group class="mb-3 col-md-3" label="Shift Start Time" for="shiftStartTime">
												<vue-timepicker
													id="shiftStartTime"
													format="hh:mm A"
													hour-label="Hour"
													minute-label="Miniutes"
													apm-label="AM/PM"
													close-on-complete
													hide-clear-button
													drop-direction="auto"
													v-model="employeeDetails.shift.startTime" />
											</b-form-group>
											<b-form-group class="mb-3 col-md-3" label="Shift End Time" for="shiftEndTime">
												<vue-timepicker
													id="shiftEndTime"
													format="hh:mm A"
													hour-label="Hour"
													minute-label="Miniutes"
													apm-label="AM/PM"
													close-on-complete
													hide-clear-button
													drop-direction="auto"
													v-model="employeeDetails.shift.endTime" />
											</b-form-group>
										</div>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Location Radius (in meter)" for="locationRadius">
											<b-form-input id="locationRadius" v-model="employeeDetails.locationRadiusBoundInMeter" />
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-4">
						<div class="card-body">
							<h4 class="card-title">Leave Details</h4>
							<div class="p-2 mt-4">
								<div class="row">
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Paid Casual leave" for="totalCasualLeave">
											<b-form-input id="totalCasualLeave" v-model="employeeDetails.leaves.TotalAnnualCasualLeavesPaid" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Paid Sick leave" for="totalSickLeave">
											<b-form-input id="totalSickLeave" v-model="employeeDetails.leaves.TotalAnnualSickLeavesPaid" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Casual leave left" for="casualLeave">
											<b-form-input id="casualLeave" v-model="employeeDetails.leaves.CasualLeaveBalanceCurrentYear" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Sick leave left" for="sickLeave">
											<b-form-input id="sickLeave" v-model="employeeDetails.leaves.SickLeaveBalanceCurrentYear" />
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-4">
						<div class="card-body">
							<h4 class="card-title">Payroll Details</h4>
							<div class="p-2 mt-4">
								<div class="row">
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Salary" for="salary">
											<b-form-input id="salary" v-model="employeeDetails.salary" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Monthly Allowed Expense" for="monthlyAllowedExpense">
											<b-form-input id="monthlyAllowedExpense" v-model="employeeDetails.monthlyAllowedExpense" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="PF Deduction" for="pfDeduction">
											<b-form-input id="pfDeduction" v-model="employeeDetails.payroll.PFDeduction" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="PF Contribution" for="pfContribution">
											<b-form-input id="pfContribution" v-model="employeeDetails.payroll.PFContribution" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="ESIC Deduction" for="esicDeduction">
											<b-form-input id="esicDeduction" v-model="employeeDetails.payroll.ESICDeduction" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="ESIC Contribution" for="esicContribution">
											<b-form-input id="esicContribution" v-model="employeeDetails.payroll.ESICContribution" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Conveyance Allowances" for="conveyanceAllowances">
											<b-form-input id="conveyanceAllowances" v-model="employeeDetails.payroll.ConveyanceAllowances" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="House Rent Allowances" for="houseRentAllowances">
											<b-form-input id="houseRentAllowances" v-model="employeeDetails.payroll.HouseRentAllowances" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Medical Allowances" for="medicalAllowances">
											<b-form-input id="medicalAllowances" v-model="employeeDetails.payroll.MedicalAllowances" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Professional Tax" for="professionalTax">
											<b-form-input id="professionalTax" v-model="employeeDetails.payroll.ProfessionalTax" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Special Allowances" for="specialAllowances">
											<b-form-input id="specialAllowances" v-model="employeeDetails.payroll.SpecialAllowances" />
										</b-form-group>
									</div>
									<div class="col-lg-6 col-md-6 col-sm-12">
										<b-form-group class="mb-3" label="Other Statutory Deductions" for="otherStatutoryDeductions">
											<b-form-input id="otherStatutoryDeductions" v-model="employeeDetails.payroll.OtherStatutoryDeductions" />
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card">
						<div class="card-body">
							<b-button class="btn-btn-outline-primary" type="submit" variant="primary">Submit</b-button>
						</div>
					</div>
				</b-form>
			</div>
		</div>
	</Layout>
</template>